import { useEffect } from 'react';

// CSS dimensions follow the visible area, including Safari's keyboard and browser bars.
export const useVisualViewport = () => {
  useEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;
    let frame;
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        // Preserve native pinch-zoom rather than resizing the UI underneath it.
        if (viewport && viewport.scale > 1.05) return;
        const height = viewport?.height || window.innerHeight;
        root.style.setProperty('--app-viewport-height', `${height}px`);
        root.style.setProperty('--app-viewport-top', `${viewport?.offsetTop || 0}px`);
        const editing = document.activeElement?.matches('input, textarea, [contenteditable="true"]');
        root.dataset.keyboardOpen = editing && window.innerHeight - height > 120 ? 'true' : 'false';
      });
    };
    update();
    window.addEventListener('resize', update);
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', update);
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
    };
  }, []);
};